import DropzoneClass from "common/utils/ui/dropzone-class";
import "./digital-assets-assets-upload-form.scss";
import digitalAssetsAssetsUploadedFiles from "./digital-assets-assets-uploaded-files";
import digitalAssetsAssetsUploadComponent from "./digital-assets-assets-upload-component";

export class DigitalAssetsAssetsUploadForm extends DropzoneClass {
  #filesComponent = digitalAssetsAssetsUploadComponent();

  #uploadedFiles = digitalAssetsAssetsUploadedFiles();

  constructor(options) {
    super({
      dropzoneSelector: options.formSelector,
      dropzoneOptions: {
        url: document.querySelector(options.formSelector)?.getAttribute("action"),
        multiple: true,
        autoQueue: true,
        autoProcessQueue: true
      }
    });
  }

  dropzoneSuccess(_, file) {
    this.#filesComponent.showFilesList();
    this.#uploadedFiles.addFile(file);
  }
}

export default () =>
  new DigitalAssetsAssetsUploadForm({
    formSelector: ".js-digital-assets-upload-assets-form"
  });
